<script lang="ts">
  
  interface Props {
    fileName: string
    onSave: () => void
    onDiscard: () => void
    onCancel: () => void
  }
  
  let { 
    fileName,
    onSave,
    onDiscard,
    onCancel
  }: Props = $props()
  
  function handleKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      onCancel()
    }
  }
</script>

<svelte:window onkeydown={handleKeydown} />

<div 
  class="modal-overlay" 
  role="dialog"
  aria-modal="true"
  tabindex="-1"
  onclick={onCancel}
  onkeydown={(e) => {
    if (e.key === 'Escape') {
      onCancel()
    }
  }}>
  <div 
    class="modal-content" 
    role="presentation"
    onclick={(e) => e.stopPropagation()}
    onkeydown={(e) => e.stopPropagation()}>
    <div class="modal-header">
      <h3>저장되지 않은 변경사항</h3>
    </div>
    
    <div class="modal-body">
      <p><span class="filename">{fileName}</span>에 저장되지 않은 변경사항이 있습니다.</p>
      <p class="sub-text">변경사항을 저장하시겠습니까?</p>
    </div>
    
    <div class="modal-footer">
      <button class="button cancel" onclick={onCancel}>
        취소
      </button>
      <div class="action-buttons">
        <button class="button discard" onclick={onDiscard}>
          저장 안 함
        </button>
        <button class="button save" onclick={onSave}>
          저장
        </button>
      </div>
    </div>
  </div>
</div>

<style>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    animation: fadeIn 0.15s ease;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  .modal-content {
    background: var(--bg-primary);
    border: 1px solid var(--border-primary);
    border-radius: 8px;
    width: 380px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    animation: slideIn 0.15s ease;
  }
  
  @keyframes slideIn {
    from {
      transform: translateY(10px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  .modal-header {
    padding: 16px 20px;
    border-bottom: 1px solid var(--border-primary);
  }
  
  .modal-header h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 500;
    color: var(--text-primary);
  }
  
  .modal-body {
    padding: 16px 20px;
  }
  
  .modal-body p {
    margin: 0 0 6px 0;
    color: var(--text-primary);
    font-size: 0.875rem;
    line-height: 1.4;
  }
  
  .modal-body p:last-child {
    margin-bottom: 0;
  }
  
  .filename {
    color: var(--accent-primary);
    font-weight: 500;
  }
  
  .sub-text {
    color: var(--text-secondary);
    font-size: 0.8125rem;
  }
  
  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    border-top: 1px solid var(--border-primary);
    background: var(--bg-secondary);
    border-radius: 0 0 8px 8px;
  }
  
  .action-buttons {
    display: flex;
    gap: 8px;
  }
  
  .button {
    padding: 6px 14px;
    border-radius: 4px;
    border: 1px solid var(--border-primary);
    background: transparent;
    color: var(--text-secondary);
    font-size: 0.8125rem;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.15s;
    outline: none;
  }
  
  .button:hover {
    background: var(--bg-secondary);
    color: var(--text-primary);
  }
  
  .button:focus-visible {
    outline: 2px solid var(--accent-primary);
    outline-offset: 1px;
  }
  
  .button.save {
    background: var(--accent-primary);
    border-color: var(--accent-primary);
    color: white;
  }
  
  .button.save:hover {
    background: var(--accent-primary);
    opacity: 0.9;
    filter: brightness(0.92);
    border-color: var(--accent-primary);
  }
  
  .button.discard {
    background: transparent;
    border-color: var(--border-primary);
    color: var(--text-secondary);
  }
  
  .button.discard:hover {
    background: var(--bg-secondary);
    color: var(--error-color, #dc2626);
  }
</style>